import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { BackButton, Loading, NOTIFICATION_TYPE, Notification } from 'components';
import { CarrierForm } from 'features/carriers/components/form/CarrierForm';
import { useGetTransporter } from 'features/carriers/hooks/useGetCarrier';

export default function EditCarrier() {
  const { id } = useParams();
  const { data: carrier, isFetching, isLoading, error } = useGetTransporter(id);

  const navigate = useNavigate();

  const onSuccess = () => {
    Notification(NOTIFICATION_TYPE.SUCCESS, 'Carrier was updated successfully');
    navigate(-1);
  };

  const onError = (error) => {
    Notification(NOTIFICATION_TYPE.DANGER, error.message);
  };

  if (isFetching || isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  return (
    <div>
      <div className="mb-4">
        <BackButton />
      </div>

      <div className="row mb-4">
        <h1>Edit Carrier</h1>
      </div>

      <CarrierForm action="edit" initialValues={carrier} onSuccess={onSuccess} onError={onError} />
    </div>
  );
}
